import React from 'react'
import { CirclePicker } from 'react-color'
import { storage } from 'helpers/firebase'

import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import IconButton from 'material-ui/IconButton'
import SignatureBox from '../components/SignatureBox'
import Image from 'material-ui-image'
import IconToggle from '../components/IconToggle'
import MenuItem from 'material-ui/Menu/MenuItem'
import { DatePicker } from 'material-ui-pickers'
import { InputAdornment } from 'material-ui/Input'
import { FormGroup, FormControlLabel } from 'material-ui/Form'
import Checkbox from 'material-ui/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import { camelToTitle } from '../helpers/transforms'

class FormField extends React.Component {
  state = {
    showPassword: false,
    signatureUrl: null
  }

  componentWillMount() {
    const { attendeeId, courseId, initialValue, type } = this.props
    if (type === 'signature' && initialValue) {
      // Value is URL to a storage path, it will be invalid by now so we need to get a new one
      storage
        .ref(`signatures/${courseId}/${attendeeId}.png`)
        .getDownloadURL()
        .then(signatureUrl => {
          this.setState({ signatureUrl })
        })
    }
  }

  render() {
    const {
      disabled,
      error,
      field,
      handleChange,
      index,
      initialValue,
      value,
      options,
      readOnly
    } = this.props
    const { showPassword, signatureUrl } = this.state

    switch (field.type) {
      case 'color':
        return (
          <div>
            <Typography
              variant="caption"
              style={{ marginTop: 5, marginBottom: 5 }}
            >
              {field.label || camelToTitle(field.key)}
            </Typography>
            <CirclePicker
              color={value}
              onChangeComplete={({ hex }) => {
                handleChange(hex)
              }}
              width="100%"
            />
          </div>
        )

      case 'date':
        return (
          <DatePicker
            autoOk={true}
            format="DD/MM/YYYY"
            label={field.label || camelToTitle(field.key)}
            error={!!error}
            helperText={error}
            value={value}
            onChange={handleChange}
            margin="normal"
            fullWidth
            disabled={readOnly || disabled}
          />
        )

      case 'boolean':
        return (
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={value}
                  onChange={event => handleChange(event.target.checked)}
                  disabled={readOnly || disabled}
                  color="primary"
                />
              }
              label={field.label || camelToTitle(field.key)}
            />
          </FormGroup>
        )

      case 'password':
        return (
          <TextField
            autoFocus={index === 0}
            label={field.label || camelToTitle(field.key)}
            error={!!error}
            helperText={error}
            id={field.key}
            type={showPassword ? 'text' : 'password'}
            value={value}
            onChange={event => handleChange(event.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={() => {
                      this.setState({ showPassword: !showPassword })
                    }}
                    onMouseDown={e => e.preventDefault()}
                  >
                    <IconToggle
                      on={showPassword}
                      onIcon={<Visibility />}
                      offIcon={<VisibilityOff />}
                    />
                  </IconButton>
                </InputAdornment>
              )
            }}
            margin="normal"
            fullWidth
            disabled={readOnly || disabled}
          />
        )

      case 'select':
        return (
          <TextField
            autoFocus={index === 0}
            label={field.label || camelToTitle(field.key)}
            error={!!error}
            helperText={error}
            id={field.key}
            select
            value={value}
            onChange={event => handleChange(event.target.value)}
            margin="normal"
            fullWidth
            disabled={readOnly || disabled}
          >
            {Object.entries(options)
              .sort(
                (a, b) =>
                  a[1][field.options.name] > b[1][field.options.name] ? 1 : -1
              )
              .map(([id, option]) => (
                <MenuItem key={id} value={id}>
                  {option[field.options.name]}
                </MenuItem>
              ))}
          </TextField>
        )

      case 'signature':
        return initialValue ? (
          <div>
            <Typography variant="caption">Signature</Typography>
            <Image
              alt="Attendee signature"
              aspectRatio={552 / 150}
              imageStyle={{ height: '150px', width: '100%' }}
              src={signatureUrl || initialValue}
            />
          </div>
        ) : (
          <SignatureBox
            error={!!error}
            helperText={error}
            onChange={handleChange}
            width={window.screen.width < 600 ? window.screen.width : false}
          />
        )

      default:
        return (
          <TextField
            autoFocus={index === 0}
            label={field.label || camelToTitle(field.key)}
            error={!!error}
            helperText={error}
            id={field.key}
            type="text"
            value={value}
            onChange={event => handleChange(event.target.value)}
            margin="normal"
            fullWidth
            multiline={field.multiline}
            rows={field.multiline ? field.rows || 4 : null}
            disabled={readOnly || disabled}
          />
        )
    }
  }
}

FormField.defaultProps = {
  value: ''
}

export default FormField



// WEBPACK FOOTER //
// ./src/components/FormField.jsx